import React from 'react';
import { Typography, Row, Col } from 'antd';
import { DollarOutlined, TrophyOutlined, SafetyOutlined } from '@ant-design/icons';
import { shopConfig } from '../../config/shop.config';

const { Title, Text, Paragraph } = Typography;

const PriceMatchSection: React.FC = () => {
  return (
    <div
      style={{
        padding: '80px 20px',
        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        color: 'white',
      }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center' }}>
        {/* Main Icon */}
        <div
          style={{
            width: '90px',
            height: '90px',
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 32px',
            backdropFilter: 'blur(10px)',
          }}
        >
          <TrophyOutlined style={{ fontSize: '45px', color: 'white' }} />
        </div>

        {/* Title */}
        <Title level={2} style={{ color: 'white', marginBottom: '16px', fontSize: window.innerWidth < 768 ? '28px' : '36px' }}>
          {shopConfig.guarantees.priceMatch.title}
        </Title>

        {/* Subtitle */}
        <Paragraph style={{ fontSize: '20px', color: 'rgba(255, 255, 255, 0.95)', marginBottom: '48px', maxWidth: '800px', margin: '0 auto 48px' }}>
          {shopConfig.guarantees.priceMatch.description}
        </Paragraph>

        {/* Features Grid */}
        <Row gutter={[32, 32]} style={{ marginTop: '48px' }}>
          <Col xs={24} md={8}>
            <div
              style={{
                padding: '32px 24px',
                backgroundColor: 'rgba(255, 255, 255, 0.15)',
                borderRadius: '12px',
                backdropFilter: 'blur(10px)',
              }}
            >
              <DollarOutlined style={{ fontSize: '40px', marginBottom: '16px' }} />
              <Title level={4} style={{ color: 'white', marginBottom: '8px' }}>
                Competitive Pricing
              </Title>
              <Text style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '15px' }}>
                Get dealer-quality service without the dealer price tag
              </Text>
            </div>
          </Col>

          <Col xs={24} md={8}>
            <div
              style={{
                padding: '32px 24px',
                backgroundColor: 'rgba(255, 255, 255, 0.15)',
                borderRadius: '12px',
                backdropFilter: 'blur(10px)',
              }}
            >
              <SafetyOutlined style={{ fontSize: '40px', marginBottom: '16px' }} />
              <Title level={4} style={{ color: 'white', marginBottom: '8px' }}>
                Quality Guaranteed
              </Title>
              <Text style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '15px' }}>
                Expert technicians with years of experience
              </Text>
            </div>
          </Col>

          <Col xs={24} md={8}>
            <div
              style={{
                padding: '32px 24px',
                backgroundColor: 'rgba(255, 255, 255, 0.15)',
                borderRadius: '12px',
                backdropFilter: 'blur(10px)',
              }}
            >
              <TrophyOutlined style={{ fontSize: '40px', marginBottom: '16px' }} />
              <Title level={4} style={{ color: 'white', marginBottom: '8px' }}>
                Beat Any Quote
              </Title>
              <Text style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '15px' }}>
                From any established shop - we'll match or beat it
              </Text>
            </div>
          </Col>
        </Row>

        {/* Bottom Text */}
        <Paragraph style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.9)', marginTop: '48px', fontStyle: 'italic' }}>
          {shopConfig.guarantees.priceMatch.subtitle}
        </Paragraph>
      </div>
    </div>
  );
};

export default PriceMatchSection;
